import { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import { useRef, useState } from 'react'
import {
  TimePickerBox,
  buildTimeOptions
} from 'components/eventComponents/TimePickerBox'
import Logger from 'services/Logger'
import { getDefaultTimezone } from 'index'

interface AbsoluteReminderTimePickerProps {
  absoluteDT: Dayjs | null
  setAbsoluteDT: React.Dispatch<React.SetStateAction<Dayjs | null>>
  noStyles?: boolean
  tz?: string
}

export default function AbsoluteReminderTimePicker({
  absoluteDT,
  setAbsoluteDT,
  tz
}: AbsoluteReminderTimePickerProps) {
  const [showTimeMinutesPopup, setShowTimeMinutesPopup] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  Logger.blue('AbsoluteReminderTimePicker:Render', {
    absoluteDT,
    tz
  })
  const resolvedTz = tz ?? getDefaultTimezone()

  const onAcceptDate = (newTime: Dayjs | null) => {
    if (!newTime) return
    setAbsoluteDT((prev) => {
      const base = (prev ?? dayjs()).clone()
      return base.hour(newTime.hour()).minute(newTime.minute()).second(0)
    })
  }

  const buildMinutes = () =>
    buildTimeOptions(dayjs().startOf('day'), undefined, true, true)

  const setTime = (newTime: Dayjs | null) => {
    if (!newTime) return
    setAbsoluteDT((prev) => {
      const base = (prev ?? dayjs()).clone()
      return base.hour(newTime.hour()).minute(newTime.minute()).second(0)
    })
  }

  return (
    <TimePickerBox
      allDay={false}
      dayjsTime={absoluteDT ?? dayjs().startOf('hour')}
      shouldScrollToTime
      shouldShowTimeDropdown
      showTimeMinutesPopup={showTimeMinutesPopup}
      setShowTimeMinutesPopup={setShowTimeMinutesPopup}
      buildMinutes={buildMinutes}
      onAcceptDate={onAcceptDate}
      setTime={setTime}
      timeoutRef={timeoutRef}
      tz={resolvedTz}
      isStartPicker={true}
      withUnderline
    />
  )
}
